// @flow
import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import { Spinner } from 'gestalt';
import { type ReactComponentType } from 'app/packages/pinterest-flow-types/react';

const localeToFileName = (locale) => {
  switch (locale.toUpperCase()) {
    case 'ID-ID':
      return 'ID';
    case 'MS-MY':
      return 'MS';
    case 'CS-CZ':
      return 'CZ';
    case 'DA-DK':
      return 'DA';
    case 'DE':
      return 'DE';
    case 'ES-ES':
      return 'ESES';
    case 'ES-MX':
      return 'ESMX';
    case 'ES-AR':
      return 'ESAR';
    case 'ES-419':
      return 'ESMX';
    case 'FR':
      return 'FR';
    case 'IT':
      return 'IT';
    case 'HU-HU':
      return 'HU';
    case 'NL':
      return 'NL';
    case 'NB-NO':
      return 'NO';
    case 'PL-PL':
      return 'PL';
    case 'PT-BR':
      return 'PTBR';
    case 'PT-PT':
      return 'PTPT';
    case 'RO-RO':
      return 'RO';
    case 'SK-SK':
      return 'SK';
    case 'FI-FI':
      return 'FI';
    case 'SV-SE':
      return 'SV';
    case 'TL-PH':
      return 'TL';
    case 'VI-VN':
      return 'VT';
    case 'TR':
      return 'TR';
    case 'EL-GR':
      return 'GR';
    case 'RU-RU':
      return 'RU';
    case 'UK-UA':
      return 'UA';
    case 'HI-IN':
      return 'HI';
    case 'TH-TH':
      return 'TH';
    case 'KO-KR':
      return 'KR';
    case 'JA':
      return 'JP';
    case 'en-GB':
      return 'ENUK';
    case 'ZH-CN':
      return 'ZHCN';
    case 'ZH-TW':
      return 'ZHTW';
    default:
      return 'ENUS';
  }
};

type PincodeCTAState = {|
  LoadedComponent: ?ReactComponentType<*>,
|};

type PincodeCTAProps = {|
  height: ?number,
  onCtaDidLoad: () => void,
  width: ?number,
|};

export default class PincodeCTA extends Component<PincodeCTAProps, PincodeCTAState> {
  static contextTypes = {
    locale: PropTypes.string,
  };

  state: PincodeCTAState = {
    LoadedComponent: null,
  };

  componentDidMount() {
    const fileName = localeToFileName(this.context.locale);
    import(`app/common/react/components/pincode/PincodeCTA/${fileName}`).then(
      ({ default: LoadedComponent }) => {
        this.setState({ LoadedComponent });
      },
    );
  }

  componentDidUpdate(prevProps: PincodeCTAProps, prevState: PincodeCTAState) {
    if (!prevState.LoadedComponent && this.state.LoadedComponent) {
      this.props.onCtaDidLoad();
    }
  }

  render() {
    const { width, height } = this.props;
    const { LoadedComponent } = this.state;
    return LoadedComponent ? (
      <LoadedComponent
        height={height}
        title={i18n._(
          'Open Pinterest and tap the camera icon for ideas',
          'accessibility label for Pincode call-to-action text',
        )}
        width={width}
      />
    ) : (
      <Spinner
        accessibilityLabel={i18n._(
          'Loading Pincode Call to Action',
          'accessibility label for loading the Pincode call-to-action image',
        )}
        show
      />
    );
  }
}
